module.exports = __webpack_public_path__ + "static/media/media-2.310ea858.jpg";